
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cause/[tagName]",
      function () {
        return require("private-next-pages/cause/[tagName]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cause/[tagName]"])
      });
    }
  